import _ from 'lodash';
import events from './events';

const registerEvents = _.noop;

export { events, registerEvents };
